import { teamNamesColors } from '../data';

export function getTeamColor(teamName) {
  return teamNamesColors.find(t => t.name === teamName)?.color || '#2F4166';
}

// Picks a readable text color on top of a team-color background. Uses YIQ
// brightness; threshold 180 flags clearly-light colors (cream, mint,
// pastel) so dark text is used there. Dark colors (including the
// semi-transparent navy of EarnSome) keep the default white text.
export function getContrastText(hex) {
  if (!hex) return '#FFFFFF';
  const cleaned = hex.replace('#', '').substring(0, 6);
  if (cleaned.length !== 6) return '#FFFFFF';
  const r = parseInt(cleaned.substring(0, 2), 16);
  const g = parseInt(cleaned.substring(2, 4), 16);
  const b = parseInt(cleaned.substring(4, 6), 16);
  const yiq = (r * 299 + g * 587 + b * 114) / 1000;
  return yiq >= 180 ? '#001B3B' : '#FFFFFF';
}

const DANCE_CYCLE = ['bounce', 'sway', 'spin', 'wiggle'];

// Assigns a dance style to each character so a row doesn't look robotic.
export function getDanceForIndex(i) {
  return DANCE_CYCLE[i % DANCE_CYCLE.length];
}

// Sparse confetti array — generated once per render via useMemo in callers.
export function buildConfetti(count = 50, palette = ['#EC5E59', '#F9C151', '#5C91F5', '#55B4BC', '#BB402A', '#3B7755']) {
  return Array.from({ length: count }, (_, id) => ({
    id,
    left: Math.random() * 100,
    delay: Math.random() * 3,
    duration: 3 + Math.random() * 3,
    size: 6 + Math.random() * 10,
    rotate: Math.random() * 360,
    color: palette[Math.floor(Math.random() * palette.length)],
    shape: Math.random() > 0.5 ? 'rect' : 'circle'
  }));
}

export function Confetti({ pieces }) {
  return (
    <div className="celebration-confetti-layer">
      {pieces.map(p => (
        <div
          key={p.id}
          className="celebration-confetti-piece"
          style={{
            left: `${p.left}%`,
            width: `${p.size}px`,
            height: p.shape === 'rect' ? `${p.size * 0.4}px` : `${p.size}px`,
            background: p.color,
            animationDelay: `${p.delay}s`,
            animationDuration: `${p.duration}s`,
            transform: `rotate(${p.rotate}deg)`,
            borderRadius: p.shape === 'circle' ? '50%' : '2px'
          }}
        />
      ))}
    </div>
  );
}
